enum DropShippingRefundStatus {
    PENDING_REFUND = "PENDING_REFUND",

    CLOSE = "CLOSE",

    SUCCESS = "SUCCESS",
}

export default DropShippingRefundStatus;
